export default ['$rootScope', 'StateUtils', 'EventHub', function ($rootScope, StateUtils, EventHub) {
    $rootScope.$on('$stateChangeSuccess', function (event, toState, params) {
        var path = StateUtils.getTrackingUrl(toState, params);
        EventHub.publish('tracking', 'pageView', {
            path: path
        });
    });
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-angular/pageViews.js
// module id = 1366
// module chunks = 0